



















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import MenuBottonPO from "@/store/entities/basedata/menupo";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import TreeSelect from "@riophae/vue-treeselect";
@Component({
  components: { TreeSelect },
})
export default class CreateMenuButton extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: 0 }) menuId: number;
  menubuttonpo: MenuBottonPO = new MenuBottonPO();
  loading: boolean = false;
  created() {
    this.menubuttonpo.isEnable = 1;
    this.menubuttonpo.menuType = 4;
  }
  create() {
    //console.log(this.list);
  }
  save() {
    (this.$refs.areaForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        this.$store
          .dispatch({
            type: "menu/checkTagName",
            data: this.menubuttonpo,
          })
          .then((val) => {
            if (val != null && val > 0) {
              this.$Modal.info({
                title: this.L("Tips"),
                content: this.L("TagNameExist"),
              });
              this.loading = false;
            } else {
              this.$store
                .dispatch({
                  type: "menu/create",
                  data: this.menubuttonpo,
                }).then((res) => {
                  this.loading = false;
                  (this.$refs.areaForm as any).resetFields();
                  this.$emit("save-success");
                  this.$emit("input", false);
                })
                .catch((err) => {
                  this.$Modal.info({
                    title: this.L("Tips"),
                    content: err,
                  });
                  this.loading = false;
                });

            }
          })
          .catch((err) => {
            this.$Modal.info({
              title: this.L("Tips"),
              content: err,
            });
            this.loading = false;
          });

        this.loading = false;
      }
    });
  }
  cancel() {
    (this.$refs.areaForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  areaRule = {
    tagName: [
      {
        required: true,
        message: this.L("TagCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    displayName: [
      {
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    sortCode: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  @Watch("menuId")
  getitemId() {
    this.menubuttonpo.parentId = this.menuId;
  }
}
